<mat-toolbar color="primary" class="nav-toolbar">
  <!-- Top Row -->
  <div class="nav-top-row">
    <!-- Mobile Menu Button (Left) -->
    <button mat-icon-button class="nav-menu-button mobile-only" (click)="toggleMobileMenu()" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
    
    <!-- Brand Section (Centered) -->
    <button mat-button [routerLink]="['/']" class="brand-button">
      <span class="brand-logo">Zodi<span class="accent">.</span></span>
    </button>

    <!-- Spacer -->
    <span class="nav-spacer"></span>

    <!-- Desktop Search -->
    <div class="desktop-search">
      <zodi-search></zodi-search>
    </div>

    <!-- User Actions -->
    <div class="user-actions">
      <!-- Mobile Search Icon -->
      <button mat-icon-button class="mobile-only" (click)="toggleSearch()" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
      
      <zodi-cart-icon></zodi-cart-icon>
      
      <!-- Wishlist Icon for Guest Users -->
      <button 
        mat-icon-button 
        *ngIf="!isUserLoggedIn" 
        routerLink="/wishlist" 
        aria-label="Wishlist"
        matTooltip="My Wishlist"
      >
        <mat-icon>favorite</mat-icon>
      </button>
      
      <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-btn" aria-label="Account">
        <mat-icon>account_circle</mat-icon>
      </button>
    </div>
  </div>

  <!-- Desktop Navigation Row (Bottom) -->
  <div class="nav-menu-row desktop-only">
    <div class="nav-menu-desktop">
      <button
        mat-button
        *ngFor="let item of navItems"
        [routerLink]="item.routerLink"
        routerLinkActive="active-nav"
        [routerLinkActiveOptions]="{ exact: item.routerLink === '/' }"
        class="nav-button"
      >
        <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
        {{ item.label }}
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Mobile Search Overlay -->
<div class="search-overlay" *ngIf="isSearchOpen" (click)="closeSearch()">
  <div class="search-overlay-content" (click)="$event.stopPropagation()">
    <div class="search-header">
      <button mat-icon-button (click)="closeSearch()" aria-label="Close">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="search-wrapper">
        <zodi-search></zodi-search>
      </div>
    </div>
  </div>
</div>

<!-- User Menu -->
<mat-menu #userMenu="matMenu">
  <!-- Logged In Menu -->
  <ng-container *ngIf="isUserLoggedIn">
    <button mat-menu-item routerLink="/profile">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </button>
    <button mat-menu-item routerLink="/orders">
      <mat-icon>receipt_long</mat-icon>
      <span>My Orders</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onLogout()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </ng-container>
  
  <!-- Not Logged In Menu -->
  <ng-container *ngIf="!isUserLoggedIn">
    <button mat-menu-item (click)="onLogin()">
      <mat-icon>login</mat-icon>
      <span>Sign In</span>
    </button>
    <button mat-menu-item (click)="onRegister()">
      <mat-icon>person_add</mat-icon>
      <span>Sign Up</span>
    </button>
  </ng-container>
</mat-menu>

<!-- Mobile Sidenav -->
<mat-sidenav-container class="sidenav-container" *ngIf="isMobileView && isMobileMenuOpen">
  <mat-sidenav
    #drawer
    mode="over"
    [opened]="isMobileMenuOpen"
    (closed)="closeMobileMenu()"
    position="end"
  >
    <mat-toolbar color="primary">
      <span>Menu</span>
      <span class="nav-spacer"></span>
      <button mat-icon-button (click)="closeMobileMenu()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>

    <mat-nav-list>
      <a
        mat-list-item
        *ngFor="let item of navItems"
        [routerLink]="item.routerLink"
        routerLinkActive="active-nav"
        [routerLinkActiveOptions]="{ exact: item.routerLink === '/' }"
        (click)="closeMobileMenu()"
      >
        <mat-icon matListIcon *ngIf="item.icon">{{ item.icon }}</mat-icon>
        <span matLine>{{ item.label }}</span>
        <span *ngIf="item.badge" class="mobile-badge">{{ item.badge }}</span>
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content></mat-sidenav-content>
</mat-sidenav-container>
